module.exports = __webpack_public_path__ + "static/media/Deposits.bbb14f58.svg";